// Touch action buttons — a phone has no Space, C or J, so on coarse-pointer devices the
// movement verbs get thumb-sized buttons (bottom-right). Taps/hold states relay over the
// "move_action" bridge message; walking stays tap-to-move and the camera stays drag.
import { useEffect, useState } from 'react';
import './TouchActions.css';

export function TouchActions({ send }: { send: (action: string) => void }) {
  const [coarse, setCoarse] = useState(false);
  const [crouched, setCrouched] = useState(false);

  useEffect(() => {
    try {
      const mq = window.matchMedia('(pointer: coarse)');
      setCoarse(mq.matches);
      const onChange = (e: MediaQueryListEvent) => setCoarse(e.matches);
      mq.addEventListener?.('change', onChange);
      return () => mq.removeEventListener?.('change', onChange);
    } catch {
      return undefined;
    }
  }, []);

  if (!coarse) return null;

  const toggleCrouch = () => {
    const next = !crouched;
    setCrouched(next);
    send(next ? 'crouch_on' : 'crouch_off');
  };

  return (
    <div className="touch-actions" aria-label="Movement buttons">
      <button type="button" className="touch-btn touch-btn--big"
              onPointerDown={() => send('jump')} aria-label="Jump">
        ⤴️
      </button>
      <button type="button" className="touch-btn"
              onPointerDown={() => send('glide')} aria-label="Glider — open or stow">
        🪂
      </button>
      <button type="button" className="touch-btn"
              onPointerDown={() => send('jet_on')}
              onPointerUp={() => send('jet_off')}
              onPointerLeave={() => send('jet_off')}
              onPointerCancel={() => send('jet_off')}
              aria-label="Jetpack — hold">
        🚀
      </button>
      <button type="button" className={`touch-btn${crouched ? ' is-on' : ''}`}
              onPointerDown={toggleCrouch} aria-label="Crouch">
        🤸
      </button>
    </div>
  );
}
